import React, { Component } from "react";
import { reduxForm, Field } from "redux-form";
import { connect } from "react-redux";
import { FormGroup, Col, Label, Input, Row, Button, Spinner } from "reactstrap";
//import DropdownList from 'react-widgets/lib/DropdownList'
//import 'react-widgets/dist/css/react-widgets.css'

import TextField from '@material-ui/core/TextField'
import Checkbox from '@material-ui/core/Checkbox'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import FormControl from '@material-ui/core/FormControl'
import Select from '@material-ui/core/Select'
import InputLabel from '@material-ui/core/InputLabel'
import FormHelperText from '@material-ui/core/FormHelperText'
import Radio from '@material-ui/core/Radio'
import RadioGroup from '@material-ui/core/RadioGroup'


const renderField = ({
    input,
    type,
    placeholder,
    label,
    disabled,
    readOnly,
    meta: { touched, error, warning },
}) => (
        <Row>
            <Col md="12">
                <Label htmlFor="{input}" className="col-form-label">
                    {label}
                </Label>
            </Col>
            <Col md="12">
                <Input
                    {...input}
                    type={type}
                    placeholder={placeholder}
                    disabled={disabled}
                    readOnly={readOnly}
                ></Input>
                {touched &&
                    ((error && <p style={{ color: "red" }}>{error}</p>) ||
                        (warning && <p style={{ color: "brown" }}>{warning}</p>))}
            </Col>
        </Row>
    );

const validate = values => {
    const errors = {}
    const requiredFields = [
        'tipo'
    ]

    const requiredFields2 = [
        'abrir'
    ]


    requiredFields.forEach(field => {
        if (!values[field]) {
            errors[field] = 'Debes seleccionar un tipo de servicio'
        }
    })

    requiredFields2.forEach(field => {
        if (!values[field]) {
            errors[field] = 'Debes seleccionar la vigencia del servicio'
        }
    })

    //if (values.email && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.email)) {errors.email = 'Invalid email address'}

    if (!values.nombre || values.nombre === "") {
        errors.nombre = "Debes ingresar nombre del servicio";
    }

    if (!values.descripcion || values.descripcion === "") {
        errors.descripcion = "Debes ingresar descripción";
    }

    if (!values.precio || values.precio === "") {
        errors.precio = "Debes ingresar precio";
    }

    if (isNaN(values.precio)) {
        errors.precio = "Precio debe ser un dato numérico";
    }

    if (parseFloat(values.precio) == 0) {
        errors.precio = "Precio debe ser mayor a cero";
    }


    if (!values.vigente || values.vigente === "") {
        errors.vigente = "Debes definir si esta vigente";
    }

    return errors
}

const renderFromHelper = ({ touched, error }) => {
    if (!(touched && error)) {
        return
    } else {
        return <FormHelperText>{touched && error}</FormHelperText>
    }
}

const renderSelectField = ({
    input,
    label,
    meta: { touched, error },
    children,
    ...custom
}) => (
        <FormControl error={touched && error}>
            <InputLabel htmlFor="age-native-simple">Tipo</InputLabel>
            <Select
                native
                {...input}
                {...custom}
                inputProps={{
                    name: 'tipo',
                    id: 'age-native-simple'
                }}
            >
                {children}
            </Select>
            {renderFromHelper({ touched, error })}
        </FormControl>
    )

const renderSelectField2 = ({
    input,
    label,
    meta: { touched, error },
    children,
    ...custom
}) => (
        <FormControl error={touched && error}>
            <InputLabel htmlFor="age-native-simple">Vigencia</InputLabel>
            <Select
                native
                {...input}
                {...custom}
                inputProps={{
                    name: 'abrir',
                    id: 'age-native-simple'
                }}
            >
                {children}
            </Select>
            {renderFromHelper({ touched, error })}
        </FormControl>
    )


const renderSelectField3 = ({
    input,
    label,
    meta: { touched, error },
    children,
    ...custom
}) => (
        <FormControl error={touched && error}>
            <InputLabel htmlFor="age-native-simple">¿Preparatoria?</InputLabel>
            <Select
                native
                {...input}
                {...custom}
                inputProps={{
                    name: 'subtipo',
                    id: 'age-native-simple'
                }}
            >
                {children}
            </Select>
            {renderFromHelper({ touched, error })}
        </FormControl>
    )



const mapStateToProps = (state) => {

    let nombre      = "";
    let descripcion = "";
    let precio      = 0.0;
    let tipo        = "";
    let abrir       = "";

    return {
        initialValues: {
            nombre: "",
            descripcion: "",
            precio: "0",
            tipo: "",
            abrir: "",
        }
    };

}; //END MAPSTATETOPROPS

class FormCatalogoCobroC extends Component {

    render() {
        return (
            <form onSubmit={this.props.handleSubmit}>
                <FormGroup row>

                    <Col md={6}>
                        <FormGroup>
                            <Field
                                type="text"
                                name="nombre"
                                component={renderField}
                                label="Nombre :"
                            />
                        </FormGroup>
                    </Col>

                    <Col md={6}>
                        <FormGroup>
                            <Field
                                type="text"
                                name="descripcion"
                                component={renderField}
                                label="Descripción :"
                            />
                        </FormGroup>
                    </Col>

                    <Col md={6}>
                        <FormGroup>
                            <Field
                                type="text"
                                name="precio"
                                component={renderField}
                                label="Precio :"
                            />
                        </FormGroup>
                    </Col>


                    <Col md={6}>
                        <FormGroup>
                            
                            <Field
                                name="tipo"
                                component={renderSelectField}
                            >
                                <option value="" />
                                <option value={'COLEGIATURA'}>COLEGIATURA</option>
                                <option value={'SERVICIO'}>SERVICIO</option>
                            </Field>

                        </FormGroup>
                    </Col>
                    
                    <Col md={6}>
                        <FormGroup>
                            <Field
                                name="abrir"
                                component={renderSelectField2}
                            >
                                <option value="" />
                                <option value={'SI'}>SI</option>
                                <option value={'NO'}>NO</option>
                            </Field>
                            
                        </FormGroup>
                    </Col>

                    <Col md={6}>
                        <FormGroup>
                            <Field
                                name="subtipo"
                                component={renderSelectField3}
                            >
                                <option value="" />
                                <option value={'PREPARATORIA'}>PREPARATORIA</option>
                            </Field>

                        </FormGroup>
                    </Col>

                </FormGroup>


                <FormGroup row>
                    <Col md="12">
                        <FormGroup>
                            

                            {
                                !this.props.submitSucceeded? (
                                    <Button
                                        color="dark"
                                        type="submit"
                                        disabled={this.props.submitSucceeded}

                                    >
                                        Enviar
                                    </Button>
                                ): (
                                        <Button variant="success" disabled>
                                            <Spinner
                                                as="span"
                                                animation="grow"
                                                size="sm"
                                                role="status"
                                                aria-hidden="true"
                                                variant="success"
                                                role="status"
                                            />
                                            Procesando solicitud...
                                        </Button>

                                    )
                            
                            }

                        </FormGroup>
                    </Col>
                </FormGroup>

            </form>
        );
    }
}

FormCatalogoCobroC = reduxForm({
    form: "formCatalogoCobroC",
    validate,
    enableReinitialize: true,
})(FormCatalogoCobroC);
export default connect(mapStateToProps, null)(FormCatalogoCobroC);
